const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evalute - evaluate joinDefinedBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const _source$separator = source.separator,
    separator = _source$separator === void 0 ? ', ' : _source$separator;
  const values = await evaluateSource(source.values, content, parentContentPath, transientContext, nativeFunctions);
  if (values && values.length) {
    const filteredValues = values.filter(item => item !== undefined && item !== null);
    if (filteredValues.length > 0) {
      return filteredValues.join(separator);
    }
  }
  return undefined;
};
module.exports = {
  evaluate
};